export let $msg
export let $dialog
export let $notice
export function initFeedback({ messageApi, dialogApi, notificationApi }) {
    $msg = messageApi
    $dialog = dialogApi
    $notice = notificationApi
    return {
        install() {
            // nothing
        },
    }
}
